import { useState, useEffect } from "react";

const Filters = ({ onFilterChange }) => {
    const [month, setMonth] = useState("");

    useEffect(() => {
        const now = new Date();
        const currentMonth = now.toISOString().slice(0, 7);
        setMonth(currentMonth);
    }, []);

    useEffect(() => {
        if (month) {
            onFilterChange(month);
        }
    }, [month]);

    return (
        <div className="bg-white border rounded-lg p-4 mb-6 flex flex-col md:flex-row md:items-center md:justify-between gap-4">

            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                {/* Label */}
                <div className="text-sm font-medium text-gray-700 text-left">
                    Select Month:
                </div>

                {/* Month input */}
                <input
                    type="month"
                    value={month}
                    onChange={(e) => setMonth(e.target.value)}
                    className="border rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
            </div>

            {/* Info */}
            <div className="text-sm text-gray-500">
                {month
                    ? `Showing data for ${new Date(
                        month + "-01"
                    ).toLocaleDateString("en-US", {
                        month: "long",
                        year: "numeric",
                    })}`
                    : "Current month"}
            </div>

        </div>
    );
};

export default Filters;